import styled from 'styled-components';
import rtl from 'styled-components-rtl';

export const StyledMMNComponent = styled.div`
  ${rtl``}
`;
